import { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import LogoSvg from '../assets/images/logo.png';
import menu2 from '../assets/images/svg/menu2.svg';
import CloseIcon from '../assets/images/svg/close-icon.svg';
import dsad from '../assets/images/home/dsad.png';
import CrossArrow from '../assets/images/svg/cross-arrow.svg';


const menuItems = [
    { label: "O nas", href: "/#o-nas" },
    { label: "Usługi", href: "/#uslugi" },
    { label: "Jak to działa", href: "/#jak-to-dziala" },
    { label: "Blog", href: "/OurBlog" },
    { label: "Kontakt", href: "/#kontakt" },
];

const Header = () => {
    const [menuOpen, setMenuOpen] = useState(false);
    const location = useLocation();

    const isActive = (href: string) => {
        if (href.startsWith("/#")) return false;
        return location.pathname === href;
    };

    return (
        <>
            {menuOpen && <div className="overlay active" onClick={() => setMenuOpen(false)}></div>}
            <header className="header" id="top-navbar">
                <div className="header-container">
                    <Link to="/" className="logo">
                        <img src={LogoSvg} alt="SprzątAsia" style={{ height: "60px", width: "auto" }} />
                    </Link>

                    <div className="hamburger" id="hamburger" onClick={() => setMenuOpen(!menuOpen)}>
                        {!menuOpen && <img src={menu2} className="menu-icon" alt="menu2" />}
                        {menuOpen && <img src={CloseIcon} alt="close-icon" className="close-icon" />}
                    </div>

                    <nav className={`nav ${menuOpen ? "open" : ""}`} id="main-menu">
                        <img className="dsad" src={dsad} alt="dsad" />

                        <div className="for-mobile-menu position-relative">
                            <Link to="/" className="mobile-logo">
                                <img src={LogoSvg} alt="SprzątAsia" style={{ height: "60px", width: "auto" }} />
                            </Link>
                            <ul className="menu">
                                {menuItems.map((item, index) => (
                                    <li key={index}>
                                        <a
                                            href={item.href}
                                            className={isActive(item.href) ? "active" : ""}
                                            onClick={() => setMenuOpen(false)}
                                        >
                                            {item.label}
                                        </a>
                                    </li>
                                ))}
                            </ul>
                        </div>

                        <div className="nav-actions">
                            <a href="https://widget.sprzatasia.pl/" target="_blank" rel="noreferrer" className="btn-quote get-quote-btn">
                                Zamów sprzątanie
                                <img src={CrossArrow} alt="cross-arrow" />
                            </a>
                        </div>
                    </nav>
                </div>
            </header>
        </>
    );
};

export default Header;
